var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4C12 4.55 11.55 5 11 5C10.91 5 10.825 4.99 10.745 4.965L8.965 6.74C8.99 6.82 9 6.91 9 7C9 7.55 8.55 8 8 8C7.45 8 7 7.55 7 7C7 6.91 7.01 6.82 7.035 6.74L5.76 5.465C5.68 5.49 5.59 5.5 5.5 5.5C5.41 5.5 5.32 5.49 5.24 5.465L2.965 7.745C2.99 7.825 3 7.91 3 8C3 8.55 2.55 9 2 9C1.45 9 1 8.55 1 8C1 7.45 1.45 7 2 7C2.09 7 2.175 7.01 2.255 7.035L4.535 4.76C4.51 4.68 4.5 4.59 4.5 4.5C4.5 3.95 4.95 3.5 5.5 3.5C6.05 3.5 6.5 3.95 6.5 4.5C6.5 4.59 6.49 4.68 6.465 4.76L7.74 6.035C7.82 6.01 7.91 6 8 6C8.09 6 8.18 6.01 8.26 6.035L10.035 4.255C10.01 4.175 10 4.09 10 4C10 3.45 10.45 3 11 3C11.55 3 12 3.45 12 4Z",
    fill: "#878889"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/rating.f3cf7bf29fc4d28c745cdf9d9667bcf2.svg";
export { ForwardRef as ReactComponent };